import {apolloClient} from '@/setup/apollo-setup'

import {
  IMPORT_BORROWERS,
  IMPORT_BORROWERS_UPDATE,
  GET_BORROWER,
  GET_BORROWER_FOR_BORROWER_SEARCH,
  GET_BORROWERS,
  GET_BORROWERS_IS_UN_APPROVED,
  GET_BORROWER_OPTIONS,
  GET_BORROWER_CONTRACT_OPTIONS,
  GET_BORROWERS_CREATED_BY_CURRENT_USER,
  CREATE_BORROWER,
  UPDATE_BORROWER,
  DELETE_BORROWER,
  APPROVED_EXTERNAL_BORROWER,
  FORCE_DELETE_BORROWER,

  IMPORT_SURETIES,
  IMPORT_SURETIES_UPDATE,
  GET_SURETY,
  GET_SURETY_FOR_BORROWER_SEARCH,
  GET_SURETIES,
  GET_SURETY_OPTIONS,
  GET_SURETY_CONTRACT_OPTIONS,
  GET_SURETIES_CREATED_BY_CURRENT_USER,
  CREATE_SURETY,
  CREATE_SURETIES_BY_BORROWER,
  UPDATE_SURETY,
  DELETE_SURETY,
  FORCE_DELETE_SURETY, GET_SURETY_FILTER_OPTIONS,
} from '@/queries/modules/customer'

import {
  error,
  addItemSuccess,
  updateItemSuccess,
  deleteItemSuccess,
  approveItemSuccess,
} from '@/utils/notification'

export async function initializing(context, payload) {
  context.commit('setInitializing', payload)
}
export async function importBorrowers(context, payload) {
    // console.log('Add ImportJob...')
    context.commit('clearError')
    context.commit('setProcessing', true)

    const variables = {
        meta: payload.meta,
        payload: payload.form
    }
    try {
        const response = await apolloClient
            .mutate({
                mutation: IMPORT_BORROWERS,
                variables,
                fetchPolicy: 'no-cache'
            })

        const {data} = await response
        const {importBorrowers} = data
        return importBorrowers
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null))
        return []
    }
}
export async function importBorrowersUpdate(context, payload) {
    // console.log('Add ImportJob...')
    context.commit('clearError')
    context.commit('setProcessing', true)

    const variables = {
        meta: payload.meta,
        payload: payload.form
    }
    try {
        const response = await apolloClient
            .mutate({
                mutation: IMPORT_BORROWERS_UPDATE,
                variables,
                fetchPolicy: 'no-cache'
            })

        const {data} = await response
        const {importBorrowersUpdate} = data
        return importBorrowersUpdate
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null))
        return []
    }
}
export async function getBorrower(context, payload) {
  // console.log('Get Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      id: payload.form.id
  }
  try {
      const response = await apolloClient
          .query({
              query: GET_BORROWER,
              variables,
              fetchPolicy: 'network-only'
          })
      const {data} = await response
      const {getBorrower: borrower} = data
      // console.log("borrower", borrower)
      context.commit('setBorrower', borrower)
      context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function  getBorrowerForBorrowerSearch(context, payload) {
  // console.log('getBorrowerForBorrowerSearch...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  if( !payload.form.id ){
    context.commit('setBorrowerSearch', null)
    context.commit('setSuccess', null)
    return
  }

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWER_FOR_BORROWER_SEARCH,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrower:  borrower } = data

    context.commit('setBorrowerSearch', borrower)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getBorrowers(context) {
  // console.log('Get Borrowers...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWERS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrowers: borrowers} = data
    // console.log("borrowers", borrowers)
    context.commit('setBorrowers', borrowers)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getBorrowersIsUnApproved(context) {
  // console.log('Get BorrowersIsUnApproved...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWERS_IS_UN_APPROVED,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrowersIsUnApproved: borrowers} = data
    context.commit('setBorrowersIsUnApproved', borrowers)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getBorrowersCreatedByCurrentUser(context) {
  // console.log('Get BorrowersCreatedByCurrentUser...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWERS_CREATED_BY_CURRENT_USER,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrowersCreatedByCurrentUser: borrowers} = data
    context.commit('setBorrowers', borrowers)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function createBorrower(context, payload) {
  // console.log('Add Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  let variables = {
      payload: payload.form
  }
  try {
      await apolloClient
          .mutate({
              mutation: CREATE_BORROWER,
              variables,
              fetchPolicy: 'no-cache'
          })
      // const {data} = await response
    if (!payload.form.isExternal){
      context.commit('setSuccess', addItemSuccess({}))
      context.commit('setBorrowerContractOptions', [])
      context.commit('setBorrowerOptions', [])
      setTimeout(async () => {
        await vm.$router.push("/customer/borrower")
      }, 200);
    }else {
      context.commit('setSuccess', null)
      return true;
    }

  } catch (e) {
      context.commit('setError', error(e.toString(), null))
    return false;
  }
}
export async function updateBorrower(context, payload) {
  // console.log('Create Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
      id: payload.id,
      payload: payload.form
  }
  try {
      await apolloClient
          .mutate({
              mutation: UPDATE_BORROWER,
              variables,
              fetchPolicy: 'no-cache'
          })
      // const {data} = await response
      context.commit('setSuccess', updateItemSuccess({}))
      context.commit('setBorrowerContractOptions', [])

      setTimeout(async () => {
        await getBorrowerOptions(context)
        await getBorrowerForBorrowerSearch(context, {form: {id: payload.id}})
        if(payload.form.isExternal){
          await vm.$router.push({ name: 'redir', params: {page:  'notification-list', action:  'ExternalBorrowerUnApproved'} });
        } else {
          await vm.$router.push("/customer/borrower")
        }
      }, 200);
      return true;
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function deleteBorrower(context, payload) {
  // console.log('Delete Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }

      const response = await apolloClient
          .mutate({
              mutation: DELETE_BORROWER,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      const {deleteBorrower: borrower} = data
      context.commit('delBorrower', borrower)
      context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function forceDeleteBorrower(context, payload) {
  // console.log('Delete Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }

      const response = await apolloClient
          .mutate({
              mutation: FORCE_DELETE_BORROWER,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      const {forceDeleteBorrower: borrower} = data
      context.commit('delBorrower', borrower)
      context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function approvedExternalBorrower(context, payload) {
  // console.log('Approve External Borrower...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }

      await apolloClient
          .mutate({
              mutation: APPROVED_EXTERNAL_BORROWER,
              variables,
              fetchPolicy: 'no-cache'
          })


      context.commit('setSuccess', approveItemSuccess({}))
      context.commit('setBorrowerContractOptions', [])
      context.commit('setBorrowerOptions', [])

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function importSureties(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      meta: payload.meta,
      payload: payload.form
  }
  try {
      const response = await apolloClient
          .mutate({
              mutation: IMPORT_SURETIES,
              variables,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      const {importSureties} = data
      return importSureties
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
    return []
  }
}
export async function importSuretiesUpdate(context, payload) {
  // console.log('Add ImportJob...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      meta: payload.meta,
      payload: payload.form
  }
  try {
      const response = await apolloClient
          .mutate({
              mutation: IMPORT_SURETIES_UPDATE,
              variables,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      const {importSuretiesUpdate} = data
      return importSuretiesUpdate
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
      return []
  }
}
export async function getSurety(context, payload) {
  // console.log('Get Surety...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      id: payload.form.id
  }
  try {
      const response = await apolloClient
          .query({
              query: GET_SURETY,
              variables,
              fetchPolicy: 'network-only'
          })
      const {data} = await response
      const {getSurety: surety} = data
       context.commit('setSurety', surety)
      context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getSuretyForSuretySearch(context, payload) {
  // console.log('getSuretyForSuretySearch...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  if( !payload.form.id ){
    context.commit('setSuretySearch', null)
    context.commit('setSuccess', null)
    return
  }

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_FOR_BORROWER_SEARCH,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getSurety:  borrower } = data

    context.commit('setSuretySearch', borrower)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getSureties(context) {
  // console.log('Get Sureties...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SURETIES,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getSureties: sureties} = data
    context.commit('setSureties', sureties)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function setSuretyOptions(context, payload) {
  // console.log('Set Surety Options...')
  context.commit('setSuretyOptions', payload ? payload : [])
}
export async function getSuretiesCreatedByCurrentUser(context) {
  // console.log('Get Sureties...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SURETIES_CREATED_BY_CURRENT_USER,
        fetchPolicy: 'network-only'
      });
    const {data} = await response
    const {getSuretiesCreatedByCurrentUser: sureties} = data
    context.commit('setSureties', sureties)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function createSurety(context, payload) {
  // console.log('Add Surety...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  let variables = {
    payload: payload.form
  }

  try {
      await apolloClient
          .mutate({
              mutation: CREATE_SURETY,
              variables,
              fetchPolicy: 'no-cache'
          })
      // const {data} = await response
      context.commit('setSuccess', addItemSuccess({}))
      context.commit('setSuretyContractOptions', [])

      if( !payload.noRedirect ){
        setTimeout(async () => {
          await getSuretyOptions(context)
          await vm.$router.push("/customer/surety")
        }, 200);
      }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function createSuretiesByBorrower(context) {
  // console.log('Add Surety...')
  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      await apolloClient
          .mutate({
              mutation: CREATE_SURETIES_BY_BORROWER,
              fetchPolicy: 'no-cache'
          })
      // const {data} = await response
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function updateSurety(context, payload) {
  // console.log('Create Surety...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
      id: payload.id,
      payload: payload.form
  }
  try {
      await apolloClient
          .mutate({
              mutation: UPDATE_SURETY,
              variables,
              fetchPolicy: 'no-cache'
          })
      // const {data} = await response
      context.commit('setSuccess', updateItemSuccess({}))
      context.commit('setSuretyContractOptions', [])

      setTimeout(() => {
        vm.$router.push("/customer/surety")
      }, 200);
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function deleteSurety(context, payload) {
  // console.log('Delete Surety...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }

      const response = await apolloClient
          .mutate({
              mutation: DELETE_SURETY,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      const {deleteSurety: surety} = data
      context.commit('delSurety', surety)
      context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function forceDeleteSurety(context, payload) {
  // console.log('Delete Surety...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }

      const response = await apolloClient
          .mutate({
              mutation: FORCE_DELETE_SURETY,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      const {forceDeleteSurety: surety} = data
      context.commit('delSurety', surety)
      context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getBorrowerContractOptions(context) {
  // console.log('Get Borrowers...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWER_CONTRACT_OPTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrowers: borrowers} = data

    context.commit('setBorrowers', borrowers)
    context.commit('setBorrowerContractOptions', borrowers)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getBorrowerOptions(context) {
  // console.log('Get Borrower Options...')

  try {
    const response = await apolloClient
      .query({
        query: GET_BORROWER_OPTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getBorrowers: borrowerOptions} = data

    context.commit('setBorrowerOptions', borrowerOptions)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}

export async function getSuretyContractOptions(context) {
  // console.log('Get Sureties...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_CONTRACT_OPTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getSureties: sureties} = data
    context.commit('setSureties', sureties)
    context.commit('setSuretyContractOptions', sureties)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getSuretyOptions(context) {
  // console.log('Get Surety Options...')

  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_OPTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getSureties: suretyOptions} = data

    context.commit('setSuretyOptions', suretyOptions)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
export async function getSuretyFilterOptions(context, payload) {
  // console.log('Get Surety Filter Options...')

  const variables =  payload ? {
    payload: payload
  } : {}

  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_FILTER_OPTIONS,
        variables,
        // fetchPolicy: 'network-only'
      })
    const {data} = await response
    const { getSuretiesByFilters: suretyOptions } = data

    context.commit('setSuretyOptions', suretyOptions)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}
export async function getSuretyFilterOptionsForProsecution(context, payload) {
  // console.log('Get Surety Options...')

  const variables =  payload ? {
    payload: payload
  } : {}

  try {
    const response = await apolloClient
      .query({
        query: GET_SURETY_FILTER_OPTIONS,
        variables,
        // fetchPolicy: 'network-only'
      })
    const {data} = await response
    const { getSuretiesByFilters: suretyOptions } = data

    context.commit('setSuretyOptions', suretyOptions)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null));
  }
}
